import { render, staticRenderFns } from "./emojiPicker.vue?vue&type=template&id=52d6b4a6&"
import script from "./emojiPicker.vue?vue&type=script&lang=ts&"
export * from "./emojiPicker.vue?vue&type=script&lang=ts&"
import style0 from "./emojiPicker.vue?vue&type=style&index=0&id=52d6b4a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports